import * as api from '../_utils/api';

export class RegisterApi {

    static async register(role: string, payload: unknown): Promise<any> {
        return api._post(`users/register?role=${role}`, payload);
    }
}
